import objectFitImages from "object-fit-images"

import { domReady } from "../utils/dom"

domReady(() => {
  objectFitImages()
})
